import { render, staticRenderFns } from "./allMatches.vue?vue&type=template&id=10607b3e"
import script from "./allMatches.vue?vue&type=script&lang=js"
export * from "./allMatches.vue?vue&type=script&lang=js"
import style0 from "./allMatches.vue?vue&type=style&index=0&id=10607b3e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports